import styled from '@emotion/styled'
import { gsColors } from '../../../styles/Variables'
import { mq } from '../../../helpers'

export const HowItWorksWrapper = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  .section-wrapper {
    width: 100%;
    max-width: 1600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &:focus {
      outline: none;
    }
  }

  .how-it-works-header {
    height: 808px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    img {
      object-fit: cover;
      z-index: 20;
      object-position: top;

      ${mq('max', '758px')} {
        object-position: 60% 0%;
      }
    }
    
    h1 {
      z-index: 30;
    }


    ${mq('max', '768px')} {
      height: 594px;
    }
  }

  .steps {
    width: 100%;
    display: flex;
    padding: 68px 88px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 54px;

    ${mq('max', '768px')} {
      padding: 44px 16px;
      align-items: flex-start;
      gap: 52px;
    }

    .steps-inner {
      width: 100%;
      border-left: 1px solid #000;
      padding-left: 104px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: flex-start;

      ${mq('max', '768px')} {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 30px;
        border: none;
        padding: 0;
      }

      .step-card {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        max-width: 345px;
      }
    }
  }

  .prepping {
    width: 100%;
    display: flex;
    flex-direction: row; 
    height: 907px;
    min-height: 907px;

    ${mq('max', '768px')} {
      flex-direction: column-reverse;
      height: auto;
    }

    .content {
      width: 50%;
      height: 100%;
      background-color: ${gsColors.cobalt};
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      ${mq('max', '768px')} {
        width: 100%;
        padding: 44px 16px;
      }

      .inner {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        margin: 0 104px 0 88px;

        ${mq('max', '1280px')} {
          margin: 0 88px;
        }

        ${mq('max', '1024px')} {
          margin: 0 44px;
        }

        ${mq('max', '768px')} {
          margin: 0;
          width: 100%;

          h2 {
            margin-bottom: 6px !important;
          }

          h3 {
            margin-bottom: 40px !important;
          }

          button {
            margin-top: 40px !important;
          }
        }

        .divider {
          width: 100%;
          border-top: 1px solid ${gsColors.salmon};
          margin: 20px 0;
        }
      }
    }
    
    .image-placeholder {
      display: block;
      width: 50%;
      height: 100%;
      height: 907px;
      position: relative;
      
      img {
        object-position: top;
        object-fit: cover;
      }

      ${mq('max', '768px')} {
        width: 100%;
        height: 498px;
      }
    }
  }

  .true-beauty {
    width: 100%;
    padding: 80px 88px 0 88px;
    background-color: ${gsColors.khaki};

    ${mq('max', '1024px')} {
      padding: 44px 16px 0;
    }

    ${mq('max', '768px')} {
      padding: 44px 16px;
    }

    .web-container {
      width: 100%;
      display: flex;
      flex-direction: row;

      ${mq('max', '768px')} {
        display: none;
      }

      .left {
        flex: 1;
        margin-right: 100px;
        position: relative;

        .title-container {
          margin-bottom: 34px;

          ${mq('max', '1130px')} {
            h2 {
              font-size: 38px;
            }
          }
        }

        .text-container {
          margin: 0 80px;

          ${mq('max', '1280px')} {
            margin: 0 40px 0 0;
          }

          ${mq('max', '1130px')} {
            margin: 0;

            p {
              font-size: 20px !important;
            }
          }
        }

        .script-image {
          position: absolute;
          right: -130px;
          top: 50%;
          transform: translateY(-50%);

          ${mq('max', '1130px')} {
            transform: translateY(-50%) scale(.8);
          }

          ${mq('max', '960px')} {
            transform: translate(-5%, -40%) scale(.7)
          }
        }
      }

      .image-placeholder {
        width: 324px;
        height: 647px;
        flex-shrink: 0;
        position: relative;
        align-self: flex-end;

        ${mq('max', '1130px')} {
          width: 280px;
          height: 559.14px;
        }

        ${mq('max', '960px')} {
          width: 200px;
          height: 399.38px;
        }

        img {
          object-fit: cover;
        }
      }
    }

    .mobile-container {
      width: 100%;
      display: none;
      
      ${mq('max', '768px')} {
        display: flex;
        flex-direction: column;
      }
      
      
      .mobile-image-container {
        width: 100%;
        height: 320px;
        padding: 0 32px;
        display: flex;
        flex-direction: row;
        margin-bottom: 34px;
        
        .mobile-left {
          height: 320px;
          width: 50%;
          position: relative;
          
          .mobile-script-image {
            position: absolute;
            right: -32px;
            top: 50%;
            transform: translateY(-50%) scale(0.6);
          }
        }
        
        .mobile-right {
          height: 320px;
          width: 50%;
          position: relative;

          img {
            object-fit: contain;
          }
        }
      }

    }
  }

  .cancellation {
    width: 100%;
    padding: 72px 16px 0;

    ${mq('max', '768px')} {
      padding: 50px 16px 10px;
    }


    .text-and-link {
      margin-bottom: 18px;
      display: flex;
      flex-direction: row;

      ${mq('max', '768px')} {
        flex-direction: column;
        align-items: center;
      }
      
      a {
        color: #000;
        &:visited {
          color: #000;
        }
      }

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
`

export const KristinEssWrapper = styled.div`
  max-width: 1600px;
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;

    h2 {
      text-align: center;
      padding: 60px 16px;

      ${mq('max', '768px')} {
        display: none;
      }
    }

    .kristin-cta {
      order: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 50px;
      padding: 60px 0;

      p {
        max-width: 80%;
        text-align: center;
      }

      .mobile-header {
        display: none;

        ${mq('max', '768px')} {
          display: block;
          padding: 0;
          text-align: left;
        }
      }

      ${mq('max', '768px')} {
        order: 1;
        padding: 60px 16px 40px 16px;
        gap: 0;

        align-items: flex-start;
        p {
          margin-top: 10px;
          text-align: left;
        }

        button {
          margin-top: 30px;
        }
      }
    }

    .images-container {
      order: 1;
      width: 100%;
      display: flex;

      ${mq('max', '768px')} {
        order: 2;
      }

      .web-only {
        ${mq('max', '768px')} {
          display: none;
        }
      }

      .image-placeholder {
        flex: 1;
        min-width: 50%;
        
        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`
